export const COUNTDOWN_INTERVAL = 1000